import { store } from '../index';
import { SideBarAction, ToggleSideBar } from './types';

export function toggleSidebar() {
  store.dispatch<SideBarAction>({
    type: ToggleSideBar,
  });
}
